import styled from "styled-components"

export const Container = styled.div`
  display: none;

  @media screen and (min-width: 1025px) {
    display: flex;
    .botao-zap-inferior img {
      bottom: 10;
    }

    .botao-zap-inferior {
      position: fixed;
      width: 80px;
      height: 60px;
      bottom: 40px;
      right: 40px;
      border-radius: 50px;
      font-size: 50px;
      z-index: 1000;
      bottom: 10;
      right: 21px;
    }
  }
`
